import React from "react";
import { Icon } from "@iconify/react";

const defaultNotifications = [
    {
        id: "demo-1",
        type: "info",
        title: "Klinik Baru Terdaftar",
        message: "Klinik Sehat Sentosa telah mendaftar dan menunggu verifikasi",
        time: "5 menit yang lalu",
        isRead: false,
        icon: "material-symbols:info-outline",
        color: "bg-blue-500",
    },
];

/**
 * @param {boolean} isOpen
 * @param {function} onClose
 * @param {Array|undefined} notifications — when provided (including []), replaces demo feed.
 * @param {function} [onMarkAllRead]
 */
const NotificationModal = ({
    isOpen,
    onClose,
    notifications: customNotifications,
    onMarkAllRead,
}) => {
    const [showAll, setShowAll] = React.useState(false);

    React.useEffect(() => {
        if (!isOpen) {
            setShowAll(false);
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const useLive =
        customNotifications !== undefined && customNotifications !== null;
    const notifications = useLive ? customNotifications : defaultNotifications;
    const unreadCount = notifications.filter((n) => !n.isRead).length;
    const displayedNotifications = showAll ? notifications : notifications.slice(0, 3);

    return (
        <>
            <div
                className="fixed inset-0 bg-black bg-opacity-20 backdrop-blur-sm z-[60] transition-opacity"
                onClick={onClose}
                aria-hidden="true"
            />

            <div className="fixed top-20 right-8 w-96 max-h-[calc(100vh-120px)] bg-white rounded-2xl shadow-2xl z-[61] overflow-hidden flex flex-col animate-[notifSlide_0.3s_ease-out]">
                <div className="bg-gradient-to-r from-[#06B6D4] to-[#0891B2] p-5 flex-shrink-0">
                    <div className="flex items-center justify-between mb-2">
                        <h3 className="text-lg font-bold text-white">Notifikasi</h3>
                        <button
                            type="button"
                            onClick={onClose}
                            className="w-8 h-8 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-all"
                        >
                            <Icon icon="material-symbols:close" className="text-white text-xl" />
                        </button>
                    </div>
                    <div className="flex justify-between items-center">
                        <p className="text-white/90 text-sm">
                            {notifications.length === 0
                                ? "Belum ada aktivitas"
                                : `Anda memiliki ${unreadCount} belum dibaca`}
                        </p>
                        {notifications.length > 0 && onMarkAllRead && (
                            <button
                                type="button"
                                onClick={() => onMarkAllRead()}
                                className="text-[11px] text-white/80 hover:text-white font-medium hover:underline transition-all"
                            >
                                Tandai semua dibaca
                            </button>
                        )}
                    </div>
                </div>

                <div className="overflow-y-auto flex-1 scrollbar-thin">
                    {notifications.length === 0 ? (
                        <div className="p-8 text-center text-sm text-gray-500">
                            Tidak ada notifikasi untuk ditampilkan.
                        </div>
                    ) : (
                        displayedNotifications.map((notification) => (
                            <div
                                key={notification.id}
                                className={`p-4 border-b border-gray-100 hover:bg-gray-50 transition-all ${
                                    !notification.isRead ? "bg-blue-50/50" : ""
                                }`}
                            >
                                <div className="flex gap-3">
                                    <div
                                        className={`w-10 h-10 ${notification.color} rounded-full flex items-center justify-center flex-shrink-0`}
                                    >
                                        <Icon icon={notification.icon} className="text-white text-xl" />
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <div className="flex items-start justify-between gap-2 mb-1">
                                            <h4
                                                className={`text-sm font-semibold ${
                                                    !notification.isRead ? "text-gray-900" : "text-gray-700"
                                                }`}
                                            >
                                                {notification.title}
                                            </h4>
                                            {!notification.isRead && (
                                                <span className="w-2 h-2 bg-[#06B6D4] rounded-full flex-shrink-0 mt-1.5" />
                                            )}
                                        </div>
                                        <p className="text-xs text-gray-600 mb-2 line-clamp-2">
                                            {notification.message}
                                        </p>
                                        <div className="flex items-center gap-1 text-xs text-gray-400">
                                            <Icon icon="material-symbols:schedule" className="text-xs" />
                                            <span>{notification.time || "—"}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>

                {notifications.length > 3 && !showAll && (
                    <div className="p-4 bg-gray-50 border-t border-gray-100 flex-shrink-0">
                        <button
                            type="button"
                            onClick={() => setShowAll(true)}
                            className="w-full py-2.5 text-sm font-semibold text-[#06B6D4] hover:text-[#0891B2] transition-colors"
                        >
                            Lihat Semua Notifikasi
                        </button>
                    </div>
                )}
            </div>

            <style>{`
                @keyframes notifSlide {
                    from { opacity: 0; transform: translateY(-20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .line-clamp-2 {
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
            `}</style>
        </>
    );
};

export default NotificationModal;
